export default "__VITE_ASSET__224ba039__"